/**
 * Origem Flow: mensagem pronta que acompanha o link de aprovação quando o
 * time toca em WhatsApp — o canal é só transporte, o link é a fonte da
 * verdade.
 */
export function buildApprovalShareMessage(approval) {
  const greeting = approval.contact_name
    ? `Olá, ${approval.contact_name}!`
    : 'Olá!'
  return (
    `${greeting} Enviamos a peça “${approval.title}” para sua aprovação.\n\n` +
    `Veja e decida por aqui (não precisa de senha):\n${approval.public_url}\n\n` +
    `Qualquer ajuste pode ser marcado direto na própria página, ` +
    `no ponto exato da peça.`
  )
}

/**
 * Mensagem pronta para o link de pendências.
 */
export function buildChecklistShareMessage(checklist) {
  const greeting = checklist.contact_name
    ? `Olá, ${checklist.contact_name}!`
    : 'Olá!'
  const count = checklist.items ? checklist.items.length : 0
  return (
    `${greeting} Para seguirmos com “${checklist.title}”, precisamos de ` +
    `${count} item(ns) seu(s).\n\n` +
    `Resolva por aqui, item a item (não precisa de senha):\n${checklist.public_url}\n\n` +
    `Os lembretes param sozinhos quando tudo estiver enviado.`
  )
}

/**
 * Mensagem pronta para o resumo da semana.
 */
export function buildDigestShareMessage(digest) {
  const greeting = digest.contact_name ? `Olá, ${digest.contact_name}!` : 'Olá!'
  const t = digest.totals || {}
  const waiting = t.waiting
    ? ` e ${t.waiting} item(ns) aguardando você`
    : ''
  return (
    `${greeting} Segue o resumo de ${digest.period.label} em ` +
    `${digest.scope_name || digest.database_name}: ${t.done || 0} entregue(s), ` +
    `${t.progress || 0} em andamento${waiting}.\n\n` +
    `Veja o detalhe por aqui (não precisa de senha):\n${digest.public_url}`
  )
}

/**
 * Mensagem pronta para o pedido de avaliação (NPS).
 */
export function buildRatingShareMessage(rating) {
  const greeting = rating.contact_name ? `Olá, ${rating.contact_name}!` : 'Olá!'
  return (
    `${greeting} Concluímos “${rating.title}” e queremos saber como foi ` +
    `para você — é uma nota de 0 a 10, leva 10 segundos:\n${rating.public_url}`
  )
}
